module.exports = __webpack_public_path__ + "static/media/20.73184e6e.mp3";